<template>
  <div class="main">
    <div class="bg-img-all">
      <!-- <div class="download-button-sub" @click="download_apk"></div> -->
      <div class="download-button-sty" @click="download_apk"></div>
      <div class="download-button-store" @click="download_apk"></div>
    </div>
  </div>
</template>

<script>
import { download, chnup, loadPage } from "../utils/tools";

export default {
  data() {
    return {};
  },
  methods: {
    download_apk: function (event) {
      chnup("click_v2");
    },
  },
  created() {
    // loadPage();
  },
};
</script>

<style lang="less" scoped>
.main {
  background: #fff;
  height: 100vh;
  width: 100vw;
}
.bg-img-all {
  width: 100vw;
  height: 177.78vw;
  background-image: url("../../static/mobile/bg.jpg");
  background-size: cover;
  position: relative;
}
.download-button-sty {
  position: absolute;
  top: 23.75vw;
  left: 14.72vw;
  width: 70.69vw;
  height: 17.78vw;
  background-image: url("../../static/mobile/download.png");
  background-size: cover;
  animation-name: scaleDraw;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-duration: 1s;
}
.download-button-store {
  position: absolute;
  top: 43.52vw;
  left: 20.97vw;
  width: 58.19vw;
  height: 15.69vw;
  background-image: url("../../static/mobile/GalaxyStore.png");
  background-size: cover;
  animation-name: scaleDraw;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-duration: 1s;
}

@keyframes scaleDraw {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.06);
  }
  50% {
    transform: scale(1.06);
  }
  75% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pageA.vue